import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Device, DeviceStatusType, RemoteServiceDiagnosisResponse } from '@vi-iot/client';
import { TrendingCategory } from 'src/app/+installations/installation/trending/trending-chart/trending-chart.helpers';

export interface RichDevice extends Device {
  selectId: string;
  loading: boolean;
  loaded: boolean;
  isNameLoaded: boolean;
  isStandalone: boolean;
  error: any;
  status: DeviceStatusType;
  shortDeviceName?: string;
  memberId?: number;
}

export interface DevicesState {
  devices: EntityState<RichDevice>;
  featuresWithPendingUpdates: string[];
  selectedDeviceId: string;
  diagnosticDataArray?: RemoteServiceDiagnosisResponse[];
  batteryModuleCategories?: TrendingCategory[];
}

export const deviceAdapter: EntityAdapter<RichDevice> = createEntityAdapter<RichDevice>({
  selectId: (device: RichDevice) => device.selectId,
});

export enum HEATING_ZONE_OPERATING_PROGRAM {
  Heating = '+INSTALLATIONS.INSTALLATION.HEATING_ZONE_OPERATING_MODE_HEATING',
  Standby = '+INSTALLATIONS.INSTALLATION.HEATING_ZONE_OPERATING_MODE_STANDY',
  Idle = '+INSTALLATIONS.INSTALLATION.HEATING_ZONE_OPERATING_MODE_IDLE',
}

export enum CircuitType {
  HeatingCircuit = 'heatingCircuit',
  TTContact = 'ttContact',
}

export const srcDeviceVkorgWhitelist = [
  '0500',
  '0600',
  '3300',
  '5000',
  '5900',
  '6000',
  '6100',
  '6200',
  '6600',
  '6800',
  '7100',
  '7300',
  '7400',
  '7500',
  '7600',
  '7700',
  '7800',
  '7900',
  '8000',
  '8700',
  '8900',
  '9000',
  '9200',
  '9500',
  '9600',
  '9700',
  '9800',
];
